import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TenantSearchableDropDownState {
    tenantDropDownDisabled: boolean;
}

type StateWithTenantSearchableDropDown = { tenantSearchableDropDown: TenantSearchableDropDownState };

const initialState: TenantSearchableDropDownState = {
    tenantDropDownDisabled: true,
};

const tenantSearchableDropDownSlice = createSlice({
    name: 'tenantSearchableDropDown',
    initialState,

    reducers: (create) => ({
        setTenantDropDownDisabled: create.reducer((state, action: PayloadAction<boolean>) => {
            state.tenantDropDownDisabled = action.payload;
        })
    })
});

// eslint-disable-next-line no-restricted-syntax
export default tenantSearchableDropDownSlice.reducer;
export const selectIsTenantDropDownDisabled = (state: StateWithTenantSearchableDropDown) => state.tenantSearchableDropDown.tenantDropDownDisabled;
export const { setTenantDropDownDisabled } = tenantSearchableDropDownSlice.actions;
